// import jQuery from 'CommonScripts/jquery-1.10.2'; 

(function (window, document, $) {
     
    $(document).ready(function () {

        if ($('.tabComponent').length > 0) {
            (function () {

                function loadOpenedTabsFromSessionStorage() {

                    if ((typeof window.sessionStorage == "undefined") || (!window.sessionStorage)) {
                        return null;
                    }

                    var openedTabsString = window.sessionStorage.getItem('openedTabs');
                    if (!openedTabsString) {
                        return null;
                    }

                    var tabs = openedTabsString.split(",");
                    for (var i = 0; i < tabs.length; i++) {
                        tabs[i] = +tabs[i];
                    }
                    
                    return tabs;
                }

                function isInPageEditor() {
                    return ($('.tabComponent ul>code').length>0);
                }

                function isDesktopVersion() {
                    return (document.documentElement.clientWidth >= 768);
                }

                function tabSpotShouldHaveFirstTabOpenedInMobile(tabSpot) {
                    return ($(tabSpot).find('.openFirstTabOnMobile').length > 0);
                }

                function getIndexOfTabToOpen(indexes) {
                    if ((typeof indexes == "undefined") || (!indexes)) {
                        return 0;
                    }
                    return indexes.shift();
                }

                function openTabInTabSpot(tabSpot, indexOfTabToOpen) {
                    $(tabSpot).find(".tabComponentLi").eq(indexOfTabToOpen).addClass("opened");
                    $(tabSpot).find(".tabComponentLi").eq(indexOfTabToOpen).find(".tabComponentContent").css("display", "block");
                }

                function setFixedHeightToTabSpotChild(tabSpot) {
                    if (!isDesktopVersion()) {
                        return;
                    }

                    var currentCss = $(tabSpot).find(".tabComponentFixedHeight").attr('class');
                    if ((typeof currentCss == 'undefined')||(currentCss == null)) {
                        return;
                    }

                    var cssFixedHeight = currentCss.match(/fixedHeight\d*/);
                    if (!cssFixedHeight || !cssFixedHeight.length) {
                        return;
                    }

                    var height = cssFixedHeight[0].match(/\d.*/);
                    $(tabSpot).find(".tabComponentFixedHeight").css("height",height+"px");
                }

                var openedTabs = loadOpenedTabsFromSessionStorage();
                var tabSpots = $(".tabComponent");
                for (var i = 0; i < tabSpots.length; i++) {

                    setFixedHeightToTabSpotChild(tabSpots[i]);

                    // in page editor, open tabs as we saved it
                    if (isInPageEditor()) {
                        var index = getIndexOfTabToOpen(openedTabs);
                        if (index >= 0) {
                            openTabInTabSpot(tabSpots[i], index);
                        }
                    }
                    // normal view
                    else {
                        // in desktop, open first tab by default. in mobile first tab should be oped only when it is set in settings
                        if (isDesktopVersion() ||
                           (!isDesktopVersion() && tabSpotShouldHaveFirstTabOpenedInMobile(tabSpots[i]))) {
                            openTabInTabSpot(tabSpots[i], 0);
                        }
                    }
                }

                window.sessionStorage.removeItem('openedTabs');
            })();
        }

        // before refresh save which tabs are opened
        window.onbeforeunload = function (event) {

            // sometimes this function is called multiple times before onload. Do not set opened tabs value, once it is set
            if (window.sessionStorage.getItem('openedTabs') !== null) {
                return;
            }

            var openedTabs = [];

            var tabSpots = $(".tabComponent");
            for (var i = 0; i < tabSpots.length; i++) {
                var isTabOpened = false;

                var tabs = $(tabSpots[i]).find(".tabComponentLi");
                for (var j = 0; j < tabs.length; j++) {
                    if ($(tabs[j]).hasClass('opened')) {
                        openedTabs.push(j);
                        isTabOpened = true;
                    }
                }

                // if no tab is opened, mark first one as opened
                if (!isTabOpened) {
                    openedTabs.push(-1);
                }
            }

            window.sessionStorage.setItem('openedTabs', openedTabs.join());
        };

    });

})(window, document, jQuery);